// extracted by mini-css-extract-plugin
module.exports = {"LabeledIcon":"LabeledIcon_LabeledIcon__m7flB","Icon":"LabeledIcon_Icon__d7WHM","Label":"LabeledIcon_Label__dgWtO"};